export const SIDEBAR_COOKIE_NAME = "sidebar:state";
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
// Open WebUI widths: a 245px expanded sidebar (their store default), the same
// width for the mobile drawer, and a 42px icon rail when collapsed.
export const SIDEBAR_WIDTH = "245px";
export const SIDEBAR_WIDTH_MOBILE = "245px";
export const SIDEBAR_WIDTH_ICON = "42px";
export const SIDEBAR_KEYBOARD_SHORTCUT = "b";
